import styled from 'styled-components';

interface ViewProps {
  isView: boolean;
}

export const Container = styled.div`
  .button-visualize-bidding {
    border: 0;
    margin: 0;
    padding: 0;
    background: none;
  }
`;

export const View = styled.div<ViewProps>`
  width: ${(props) => (props.isView ? '50px' : '40px')} !important;
  height: 24px !important;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: ${(props) => (props.isView ? '5px' : '0px')} !important;
`;
